import { render, staticRenderFns } from "./inputDefault.vue?vue&type=template&id=b4f346d4"
import script from "./inputDefault.vue?vue&type=script&lang=js"
export * from "./inputDefault.vue?vue&type=script&lang=js"
import style0 from "./inputDefault.vue?vue&type=style&index=0&id=b4f346d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports